import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_REQUESTFORQUOTATION } from "../../../../utils/constants";
import { RFQInterface } from "../../../../models/ProcurementModule/RequestForQuotation";
import RFQService from "../../../../services/procurementService/RFQService";

const useRFQ = (page: number, pageSize: number) =>
  useQuery<RFQInterface[], Error>({
    queryKey: [CACHE_KEY_REQUESTFORQUOTATION, page, pageSize],
    queryFn: () => RFQService.GetAll(page, pageSize),
    initialData: [],
  });

export default useRFQ;
